import { Component, Input } from '@angular/core';
import { ListDefaults, TableService } from '@fry/lib/list';
import { EasTable, EasTableRow, TableSource } from '@fry/lib/store';
import { asyncScheduler, scheduled } from 'rxjs';
import { InteractiveTableOptions } from '../list/interactive-table/interactive-table.component';


const defaultOptions: InteractiveTableOptions = {
  enableFilters: false,
  enableExport: false,
  enableColumns: true,
  enableSelection: false,
  enablePagination: true,
  itemSingleLabel: $localize `item`,
  itemPluralLabel: $localize `items`,
}

@Component({
    selector: 'fixed-data-table',
    templateUrl: './fixed-data-table.component.html',
    styleUrls: [],
    providers: [
        TableService
    ],
    standalone: false
})
export class FixedDataTableComponent {
  @Input() options!: Partial<InteractiveTableOptions>;
  @Input() listId: string = 'general';
  @Input() table: EasTable = {columns: [], data: []};
  private _tableData: EasTableRow[] = [];
  @Input() defaultColumns: string[] = [];

  public tableOptions = defaultOptions;

  constructor(private tableService: TableService) {}

  ngOnInit() {
    this.loadItems().subscribe();
  }

  ngOnChanges() {
    this._tableData = this.table.data;
    this.tableOptions = {
      ...defaultOptions,
      ...this.options
    }
  }

  loadItems() {
    const defaults: ListDefaults = {};
    defaults.fixedSearchModel = {
      filter: {},
      sort: {},
      select: this.defaultColumns,
    };
    return this.tableService
      .setupWith(this.getGenericTableSource(),
        defaults,
        'general'
      );
  }

  getGenericTableSource(): TableSource {
    return {
      table: (params: any) => {
        var tableMeta = params.pagination;
        if (!tableMeta.total) {
          tableMeta.total = this._tableData.length;
        }

        const endIndex = tableMeta.start + tableMeta.size;
        this.table.data = this._tableData.slice(tableMeta.start, endIndex);

        const table: EasTable = { ...this.table, meta: { ...tableMeta, selectedColumns: this.defaultColumns } };
        return scheduled([table], asyncScheduler);
      },
    }
  }
}
